module.exports = __webpack_public_path__ + "media/images/filters/checkbox-empty-34796dfb94af2d0f000c7ac38e654965.png";